export const verifyEmail = (isAuthenticated) => {
  return function (dispatch) {
    dispatch({ type: "UPDATE_AUTHENTICATED", payload: isAuthenticated });
  };
};

export const updateAuthenticated = (isAuthenticated) => {
  return function (dispatch) {
    dispatch({ type: "UPDATE_AUTHENTICATED", payload: isAuthenticated });
  };
};

export const updateUser = (user) => {
  return function (dispatch) {
    dispatch({ type: "UPDATE_USER", payload: user });
  };
};

/* export const handleResponse = ({}) => {
    return function(dispatch) {
        dispatch({ type: "UPDATE_USER", payload: user });
    };
}

export const ajaxRequest = ({}) => {
    axios.get('https://dog.ceo/api/breeds/image/random')
    .then(response => {
        handleResponse(dispatch);
    })
    .catch(error => {
         
    });
}
 */
